/** Registers the app-shell service worker (public/sw.js) - see that file for what it does and doesn't cache. */
export function registerServiceWorker() {
  if ("serviceWorker" in navigator && import.meta.env.PROD) {
    window.addEventListener("load", () => {
      // updateViaCache: "none" - don't let the browser's HTTP cache mask a
      // changed sw.js the way it can mask other static files; always go to
      // the network to check whether this file's bytes have changed.
      navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" }).catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("Service worker registration failed:", err);
      });
    });
  }
}